var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWedgeInActiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 32,
    viewBox: "0 0 27 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.58 0.347656L26.2335 1.60488L25.5999 2.94239L24.228 4.12221L12.1517 29.5893C11.9195 30.081 11.4722 30.438 10.9418 30.5555C7.99299 31.2092 4.94525 31.2881 1.96632 30.7906C0.879685 30.6086 0.0654253 29.6968 0.00808309 28.5959C-0.0764967 26.9688 0.505527 25.379 1.62083 24.1905C1.89894 23.8952 2.31181 23.7633 2.71033 23.8436C5.85556 24.4816 8.84882 25.7144 11.531 27.4734L22.902 3.49288L22.9464 1.68516L23.58 0.347656Z",
    fill: "#8D9091"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWedgeInActiveIcon);
export default __webpack_public_path__ + "static/media/wedgeInActiveIcon.50d7e9eab84c98aa604c2cd07ad5dc0f.svg";
export { ForwardRef as ReactComponent };